import currentGradYear from '../current-grad-year'
import { get } from 'lodash'

const getUserGradeLevel = (user = {} ) => {
    const gradYear = get(user, 'gradYear');
    if (gradYear) {
        return parseInt(gradYear) - currentGradYear;
    }
    return undefined;
}

export default getUserGradeLevel